module.exports = __webpack_public_path__ + "img/warn-icon-red.6af9b318.svg";